import React, { useState, useEffect } from "react";
import X from "../../../../assets/images/CT/X.png";
import Conspiracy from "../../../../assets/images/CT/conspiracy.png";
import Checkmark from "../../../../assets/images/CT/checkmark.png";

import { connect } from "react-redux";
import _ from "lodash";

const TurnResult = (props) => {
  const { question, chosen_answer, active_player_details } = props;
  const playingParams = _.get(props, "paramsReducer.gameObj.2_playing");
  const categoryParams = _.get(props, "paramsReducer.gameObj.category");
  const question_category = _.get(question, "category");
  const answers = _.get(question, "answers");
  const correct_answer = _.get(question, "correct_answer");
  const conspiracy_url = _.get(question, "url");

  return (
    <>
      <div className="ct-tech-content">
        <div className="ct-tech-inner-content">
          {question_category === "Tech" && (
            <div className="tech-top tech">
              <h2>{categoryParams.tech}</h2>
            </div>
          )}

          {question_category === "Random" && (
            <div className="tech-top random">
              <h2>{categoryParams.random}</h2>
            </div>
          )}

          {question_category === "Aliens" && (
            <div className="tech-top aliens">
              <h2>{categoryParams.aliens}</h2>
            </div>
          )}

          {question_category === "Schemes" && (
            <div className="tech-top schemes">
              <h2>{categoryParams.schemes}</h2>
            </div>
          )}

          {question_category === "Mythos" && (
            <div className="tech-top mythos">
              <h2>{categoryParams.mythos}</h2>
            </div>
          )}

          <div className="tech-bottom">
            <div className="content">
              <h6>{question?.prompt}</h6>
              <p>{answers[chosen_answer]}</p>
            </div>
            <div className="conspiracy-text">
              <button
                onClick={() => {
                  window.open(conspiracy_url, "_blank");
                }}
              >
                <img src={Conspiracy} alt="Conspiracy" />
                {playingParams.learn_the_conspiracy}
              </button>
              <p className="mb-0">
                {active_player_details?.display_name} answered{" "}
                {correct_answer === chosen_answer ? "correctly" : "incorrectly"}
                {correct_answer === chosen_answer ? (
                  <img src={Checkmark} alt="Checkmark" />
                ) : (
                  <img src={X} alt="X" />
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(TurnResult);
